import { useEffect, useState } from "react"
import { useSelector } from "react-redux"


import SimpleBoxDisplay from "../../../common/SimpleBoxDisplay"
import CustomSelect from "../../../common/interactive/CustomSelect"
import InputBox from "../../../common/interactive/InputBox"
import InputBoxCurrencyAlternative from "../../../common/interactive/InputBoxCurrencyAlternative"

import { getMedPayPolicyLimitsLabel } from "../../../../lib/labels"
import { returnPrimaryInsuranceOrTheNextActiveOne } from "../../../../lib/primaryItemScripts"
import Tag from "../../../fragments/Tag"

import classes from './NegotiationRow.module.css'
import { isStateOfPip } from "../../../../lib/script"
import { frontendOptions } from "../../../../lib/systemData"

// const mockStatusMedPay = [
//     {
//         label: 'Recieved by office',
//         value: 'Recieved by office'
//     },
//     {
//         label: 'Atty got MedPay',
//         value: 'Atty got MedPay'
//     },
//     {
//         label: 'Patient got MedPay',
//         value: 'Patient got MedPay'
//     },
//     {
//         label: 'Other',
//         value: 'Other'
//     }
// ]

export default function NegotiationMedPay({updateHandler}) {
    const activeCase = useSelector(state => state.case.activeCase) 

    const [medpayData, setMedpayData] = useState(null)

    useEffect(() => {
        
        if (activeCase && activeCase.mp_pip_um) {
            let primary = returnPrimaryInsuranceOrTheNextActiveOne(activeCase, 'mp_pip_um')
           
            if (primary) {
                setMedpayData(primary)
            }
            
        }
    }, [activeCase])



    return <div className={classes.container}>
        <div className={`${classes.row}  ${classes.row_header}`}>
            <h3>MedPay</h3>
            {medpayData && <div className={classes.header_side}>
                {/* always check for state of pip when dealing with has_pip  */}
                {isStateOfPip(medpayData?.insurance_state) && <> 
                    {medpayData.has_pip == 1 && medpayData.pip_exausted == 0 ? <Tag color={'Green'}>PIP</Tag> : ''}
                    {medpayData.has_pip == 0 && medpayData.pip_exausted == 0 ? <Tag color={'RedG'}>No PIP</Tag> : ''}
                    {medpayData.has_pip == 1 && medpayData.pip_exausted == 1 ? <Tag color={'RedG'}>PIP Exausted</Tag> : ''}
                </>}


                {medpayData.mp_exausted == 1 ? <Tag color={'RedG'}>MP Exausted</Tag> : ''}
                {medpayData.has_mp == 1 && medpayData.mp_exausted == 0 ? <Tag color={'Green'}>MP</Tag> : ''}
                {medpayData.has_mp == 0 && medpayData.mp_exausted == 0 ? <Tag color={'RedG'}>No MP</Tag> : ''}
            </div>}
        </div>
        {medpayData && <>
            <div className={classes.row}>
                <SimpleBoxDisplay label={'Insurance company'} value={medpayData.insurance_carrier?.name}/>
            </div>
            <div className={`${classes.row} ${classes.row_flex}`}>
                {/* always check for state of pip when dealing with has_pip  */}
                {isStateOfPip(medpayData?.insurance_state) ? (
                    (medpayData.pip_policy_limit != null && medpayData.pip_policy_limit !== '' && medpayData.pip_policy_limit !== 0 && medpayData.pip_policy_limit !== '0')
                        ? <SimpleBoxDisplay label={'PIP Limit'} value={getMedPayPolicyLimitsLabel(medpayData.pip_policy_limit)}/>
                        : null
                ) : null}
                
                {(medpayData.mp_policy_limit != null && medpayData.mp_policy_limit !== '' && medpayData.mp_policy_limit !== 0 && medpayData.mp_policy_limit !== '0')
                    ? <SimpleBoxDisplay label={'MP Limit'} value={getMedPayPolicyLimitsLabel(medpayData.mp_policy_limit)}/>
                    : null}
            </div>                        

            <div className={`${classes.row} ${classes.row_flex}`}>
                <CustomSelect action={updateHandler} label={'Negotation Status'} optionsData={frontendOptions()?.MP_NEG_STATUS} preSelectedValue={activeCase.case_negotiation?.medpay_status} identifier={{type: 'case_negotiation', field: 'medpay_status', type_id: null, folder: 'case_negotiation'}} bkTransparent={true} hasRemove={true}/>
                {activeCase.case_negotiation?.medpay_status == 'Other' && <div className={classes.row}>
                    <InputBox action={updateHandler} label={'Other Status'} currentValue={activeCase.case_negotiation?.medpay_other_status} identifier={{type: 'case_negotiation', field: 'medpay_other_status', type_id: null, folder: 'case_negotiation'}}/>
                </div> }  
            </div>
            <div className={classes.row}>
                <InputBoxCurrencyAlternative action={updateHandler} label={'Medpay Collected'} currentValue={activeCase.case_negotiation?.medpay_collected} identifier={{type: 'case_negotiation', field: 'medpay_collected', type_id: null, folder: 'case_negotiation'}}/>
            </div>
        </>}
    </div>
}